export const smartsightAPI = "https://helpdesk.simpliforce.com/";
